import gql from 'graphql-tag';

export const DELETE_USERS = gql`
  mutation UpdateUsers($id: uuid!, $status: uuid!) {
    update_adn_users(where: { id: { _eq: $id } }, _set: { status_id: $status }) {
      returning {
        id
      }
    }
  }
`;

export const BLOCK_USERS = gql`
  mutation UpdateUsers($id: uuid!, $blocked: Boolean!) {
    update_adn_users(where: { id: { _eq: $id } }, _set: { blocked: $blocked }) {
      returning {
        id
        blocked
      }
    }
  }
`;

export const UPDATE_PROFILE_PHOTO = gql`
  mutation($file: Upload!) {
    uploadImageProfile(file: $file) {
      url
    }
  }
`;

export const INSERT_USER = gql`
  mutation InsertUsers(
    $roleId: uuid!
    $email: String!
    $statusId: uuid!
    $name: String!
    $lastName: String!
    $secondLastName: String!
    $clientId: uuid
    $profilePicture: String
  ) {
    insert_adn_user_people(
      objects: {
        user: {
          data: {
            blocked: false
            confirmed: true
            email: $email
            role_id: $roleId
            status_id: $statusId
            client_id: $clientId
            profile_picture: $profilePicture
          }
        }
        status_id: $statusId
        person: {
          data: {
            name: $name
            last_name: $lastName
            second_last_name: $secondLastName
            status_id: $statusId
          }
        }
      }
    ) {
      affected_rows
      returning {
        id
        user {
          id
          email
        }
        person {
          id
        }
      }
    }
  }
`;

export const EDIT_USER = gql`
  mutation editUser(
    $user: adn_users_set_input
    $id: uuid!
    $peopleId: uuid!
    $people: adn_people_set_input!
  ) {
    update_adn_users(where: { id: { _eq: $id } }, _set: $user) {
      returning {
        id
        email
      }
    }
    update_adn_people(where: { id: { _eq: $peopleId } }, _set: $people) {
      returning {
        id
      }
    }
  }
`;

export const LOGIN_USER = gql`
  mutation LoginAdNUser($email: String!) {
    loginAdNUser(input: { where: { email: $email } }) {
      jwt
      role {
        id
        name
        code_name
        role_permissions {
          module {
            id
            name
            code_name
          }
          submodule {
            id
            name
            code_name
          }
          function {
            id
            name
            code_name
          }
          action
          enabled
        }
      }
      userId
      message
      user {
        id
        email
        username
        client_id
        profile_picture
        user_people {
          person {
            id
            name
            last_name
            second_last_name
          }
        }
      }
    }
  }
`;
